// nav-menu.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StorageKeys } from 'src/app/shared-module-files/simpo.constant';


@Injectable({
  providedIn: 'root',
})

export class NavMenuService {
  public filters: any = {};
  public pageNo: number = 0;
  public pageSize: number = 10;

  // Emits once when the app-code map is built for the first time per session
  codeMapReady$ = new Subject<void>();

  constructor(private http: HttpClient) {
  }

  clear() {
    this.filters = {};
    this.pageNo = 0;
    this.pageSize = 10;
  }

  // Fetch the nav data from API
  getNavData(businessType: any): Observable<any[]> {
    const businessId = localStorage.getItem('businessId');
    const deviceType = 'WEB'
    const staffId = localStorage.getItem('staffId')

    return this.http.get<any[]>(
      environment.baseUrl + `app/app/navbar?businessId=${businessId}&businessType=${businessType}&deviceType=${deviceType}&staffId=${staffId}`
    )
      .pipe(
        tap((res: any) => this.cacheAppCodeMap(res)),
        catchError((error) => {
          return throwError(() => new Error('Failed to fetch navigation data.'));
        })
      );
  }

  // Builds and caches a name→code map so getStaffPermission can resolve
  // name-based keys (e.g. 'CRM', 'CAMPAIGN') to backend codes (e.g. 'APP2CE9B091A7E84')
  private cacheAppCodeMap(res: any): void {
    const apps: any[] = res?.data || (Array.isArray(res) ? res : []);
    const appNameToCode: Record<string, string> = {};
    const subAppCodeByAppCode: Record<string, Record<string, string>> = {};

    // Same normalization as getStaffPermission: uppercase + spaces/hyphens → underscore
    const norm = (s: string) => (s || '').toUpperCase().replace(/[\s-]+/g, '_').trim();

    for (const app of apps) {
      if (!app.code) continue;

      // Map every possible name variant so components can use any of them
      for (const name of [app.appName, app.displayName, app.code]) {
        if (name) appNameToCode[norm(name)] = app.code;
      }

      subAppCodeByAppCode[app.code] = {};
      for (const sub of app.subAppName || []) {
        if (!sub.code) continue;
        for (const name of [sub.subAppName, sub.displayName, sub.code]) {
          if (name) subAppCodeByAppCode[app.code][norm(name)] = sub.code;
        }
      }
    }

    const wasEmpty = !localStorage.getItem(StorageKeys.APP_CODE_MAP);
    localStorage.setItem(StorageKeys.APP_CODE_MAP, JSON.stringify({ appNameToCode, subAppCodeByAppCode }));

    // Notify subscribers on first build so components can re-read permissions with resolved codes
    if (wasEmpty) this.codeMapReady$.next();
  }

  markAppPinned(appId: any, isFav: boolean) {
    const businessId = localStorage.getItem('businessId');
    const deviceType = 'WEB'
    const staffId = localStorage.getItem('staffId')

    return this.http.post(
      environment.baseUrl + `app/app/mark-favorite?businessId=${businessId}&appId=${appId}&staffId=${staffId}&isFavorite=${isFav}&displayOrder=1&deviceType=${deviceType}`, ''
    )
  }


  isAppInstalled(app: string, bId?: any) {
    const businessId = bId || localStorage.getItem('businessId');
    return this.http.get(environment.baseUrl + `app/app/check-app?businessId=${businessId}&appName=${app}`)
  }
}
